export enum LocalStorageKey {
  SettingLocale = 'setting-locale',
  SettingUnit = 'setting-unit',
  SettingClampingLevel = 'setting-clamping-level',
  SettingsNewsLastUpdate = 'setting-news-last-update',
  SettingsNewsLastVisit = 'setting-news-last-visit',
  SettingsNewsIsVisited = 'setting-news-is-visited',
}
